import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7afeed5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumbs" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Icon"], {
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push('/'))),
      name: "Home",
      style: {"height":"1em"}
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.breadcrumbs, (breadcrumbElement, index) => {
      return (_openBlock(), _createElementBlock("span", {
        key: breadcrumbElement.name
      }, [
        _hoisted_2,
        _createVNode(_component_router_link, {
          class: _normalizeClass({disabled: index == $setup.breadcrumbs.length - 1}),
          to: breadcrumbElement.path
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($setup.getDisplayedName(breadcrumbElement)), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "to"])
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}